module.exports = __webpack_public_path__ + "static/img/vr1.0538183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vr1.jpg
// module id = +ZRN
// module chunks = 1